import React from 'react';
import { bool, func, string } from 'prop-types';
import { Field, Form, reduxForm } from 'redux-form';
import { Button, ButtonGroup, Col, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

import FieldWrapper from 'components/common/FieldWrapper';
import { duplicatePartnerValidation } from './validations';

export function DuplicatePartnerForm({
  error,
  handleClose,
  handleSubmit,
  pristine,
  submitting
}) {
  return (
    <Form onSubmit={handleSubmit}>
      {error && (
        <p className="text-danger text-center">
          <strong>Error: {error}</strong>
        </p>
      )}
      <Row>
        <Col xs={12}>
          <Field
            autofocus
            component={FieldWrapper}
            hideLabelInError
            inputComponent="textarea"
            inputComponentProps={{
              autoFocus: true,
              className: 'form-control',
              rows: 6
            }}
            label="Additional Information"
            name="additional_information"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="margin-bottomgap20 text-center">
          <ButtonGroup className="pull-right">
            <Button bsStyle="warning" onClick={handleClose}>
              <FontAwesome name="ban" tag="i" />
              {' Cancel'}
            </Button>
            <Button
              bsStyle="success"
              disabled={pristine || submitting}
              type="submit"
            >
              <FontAwesome name="paper-plane" tag="i" />
              {' Submit'}
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    </Form>
  );
}

DuplicatePartnerForm.propTypes = {
  error: string,
  handleClose: func.isRequired,
  handleSubmit: func.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired
};

DuplicatePartnerForm.defaultProps = {
  error: ''
};

export default reduxForm({
  form: 'duplicatePartnerForm',
  validate: duplicatePartnerValidation
})(DuplicatePartnerForm);
